import { Injectable } from '@angular/core';
import {BehaviorSubject, Observable, Subject} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AppService {

  public appDataReloadSubject: Subject<boolean> = new Subject<boolean>();
  public languageChangeSubject: BehaviorSubject<string> = new BehaviorSubject<string>('en');

  protected currentLanguage: string = 'en';
  protected currentApiUrl: string = null;


  /**
   * Constructor
   *
   */
  public constructor() { }

  /**
   * Accessor to get the language
   *
   * @return {string}
   */
  public get language(): string {
    return this.currentLanguage;
  }

  /**
   * Mutator to set the language
   *
   * @param {string} language
   */
  public set language(language: string) {
    if (this.currentLanguage !== language) {
      this.currentLanguage = language;
      this.languageChangeSubject.next(language);
    }
  }

  /**
   * Listener for when the language changed
   *
   * @return {Observable<string>}
   */
  public getLanguageChanged(): Observable<string> {
    return this.languageChangeSubject.asObservable();
  }

  /**
   * Accessor to get the language
   *
   * @return {string}
   */
  public get apiUrl(): string {
    return this.currentApiUrl;
  }

  /**
   * Mutator to set the api Url
   *
   * @param {string} url
   */
  public set apiUrl(url: string) {
    this.currentApiUrl = url;
  }

  /**
   * Observable that the AppData is loaded
   *
   * @return {Observable<boolean>}
   */
  public appDataReload(): Observable<boolean> {
    return this.appDataReloadSubject.asObservable();
  }

  /**
   * Trigger the even that the app Data needs to be reloaded
   */
  public triggerAppDataReload(): void {
    this.appDataReloadSubject.next(true);
  }
}
